import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'group/tile relative z-0 flex w-full flex-col overflow-hidden bg-transparent p-0 max-md:pb-4 md:p-0',
    link: 'absolute inset-0 z-100 cursor-pointer !opacity-0',
    imageContainer: 'relative w-full',
    imageWrapper: 'relative h-full w-full bg-transparent',
    image:
      'aspect-[303/324] h-[96px] w-[96px] rounded-[8px] object-contain md:h-[112px] md:w-[112px]',
    labels:
      'absolute -top-2 -left-2 flex max-w-[180px] flex-wrap gap-1 max-md:right-8 md:-top-4 md:-left-4',
    productOverlay: 'product-overlay',
    checkbox: 'absolute bottom-7 left-4 z-30',
    outOfStockLabel:
      'absolute top-1/2 left-1/2 z-20 z-101 -translate-x-1/2 -translate-y-1/2 transform font-medium',

    content: 'mt-4 flex flex-1 flex-col md:mt-4',
    header: 'relative flex items-center justify-between',
    brandContainer: 'relative z-20',
    options: 'relative z-20',
    rating:
      'heading-xs md:heading-s -top-8 flex items-center gap-1.5 rounded-full bg-white px-2 max-md:absolute',
    starIcon: 'text-icon-star size-4',
    info: '',
    title:
      'min-xl:heading-xs max-xl:heading-xs min-xl:heading-xs max-xl:heading-xs heading-xs group-hover/tile:text-brand-400 line-clamp-2 min-h-6 text-center font-normal',
    description:
      'md:heading-s heading-xs mt-1 line-clamp-2 min-h-10 md:min-h-12',
    bottom: 'mt-0 flex flex-col gap-1 md:gap-0',
    actions: 'relative z-20 z-101 mt-1 flex flex-col gap-1 md:mt-0',
    actionButton: '',
    buttonBuyPrice: 'justify-center max-md:items-start max-md:gap-1 max-md:p-0',
    buttonBuyPriceValue: 'heading-xl md:heading-m-bold',
    wishlist:
      'absolute top-0 right-0 z-101 size-6 group-hover/tile:opacity-100 md:size-8 md:opacity-0',
    compare:
      'absolute top-8 right-0 z-101 size-6 cursor-pointer group-hover/tile:opacity-100 md:top-10 md:size-8 md:opacity-0',
    compareIcon: 'hover:[&>path]:stroke-icon-brand h-full w-full',
    button: 'size-[48px] max-xl:absolute max-xl:right-0 max-xl:-bottom-5'
  }
});
